module.exports = "<div class=\"padding padding-10\">\r\n  <app-auto-complete-facilities-search\r\n    [clearAfterSearch]=\"true\"\r\n    (emitterSelected)=\"onSelectFacilty4Payor($event)\"\r\n  >\r\n  </app-auto-complete-facilities-search>\r\n</div>\r\n<div class=\"container\" appHeight=\"70vh - 90px\" [less]=\"less\">\r\n<ag-grid-angular\r\n             [gridOptions]=\"gridFacilitysPayor\"\r\n             (cellDoubleClicked)=\"OnCellDoubleClicked($event)\">\r\n</ag-grid-angular>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/payors/payor-facilities/payor-facilities.component.html
// module id = 2488
// module chunks = 66